import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StepsComponent } from "./steps/steps.component";
import { TextboxComponent } from "./textbox/textbox.component";
import { PopupComponent } from './popup/popup.component';
import { DragndropDirective } from "../directives/dragndrop.directive";

@NgModule({
  declarations: [StepsComponent, TextboxComponent, PopupComponent,DragndropDirective],
  imports: [CommonModule],
  exports: [StepsComponent, TextboxComponent, PopupComponent, DragndropDirective],
})
export class ComponentsModule {}
